import { CTAButton } from "./CTAButton";
import { CHECKOUT_URL, CLOSE_DATE } from "../../lib/assets";
import { CountdownTimer } from "./CountdownTimer";
import { TESTIMONIALS } from "../../lib/testimonials";
import { TestimonialBar } from "./TestimonialBar";

const Check = () => (
  <svg
    className="w-4 h-4 flex-shrink-0 text-[#C9587E] mt-1"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
  </svg>
);

const includedFeatures = [
  "6 months of direct voice note access",
  "Monday through Friday",
  "Responses within 24 hours (the occasional emergency happens)",
  "A master hypnotherapist and certified therapist tracking your patterns and cleaning up your cobwebs",
];

export const Pricing = () => {
  return (
    <section
      id="offers"
      className="relative py-28 md:py-40 bg-[#F7E9EC] border-y border-[#EDD9DE] scroll-mt-20"
      data-testid="pricing-section"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <article
          className="relative rounded-2xl border border-[#C9587E]/40 bg-[#FFFCFB] p-10 md:p-16 shadow-ambient"
          data-testid="card-goldmine"
        >
          <h3 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-[#3B2630] tracking-tight text-center">
            The <span className="italic text-[#C9587E]">Goldmine</span>
          </h3>

          <div className="warm-divider-h my-10" />

          <div className="text-center mb-10">
            <div
              className="font-serif text-6xl md:text-7xl font-light text-[#3B2630] tabular-nums"
              data-testid="price-goldmine"
            >
              $4,999
            </div>
            <p className="font-body text-sm uppercase tracking-[0.2em] text-[#97808A] mt-4">
              Usually <span className="line-through">$10,000</span>
            </p>

            <div className="mt-10" data-testid="price-countdown-wrap">
              <p className="font-body uppercase tracking-[0.3em] text-[10px] text-[#C9587E] font-semibold mb-6">
                The investment doubles to $10,000 in
              </p>
              <CountdownTimer target={CLOSE_DATE} size="md" testid="price-countdown" />
            </div>
          </div>

          <p className="font-body uppercase tracking-[0.3em] text-[10px] text-[#C9587E] font-semibold mb-6 text-center">
            What&rsquo;s included
          </p>
          <ul className="space-y-4 mb-10">
            {includedFeatures.map((f) => (
              <li
                key={f}
                className="flex gap-3 font-body text-sm md:text-base text-[#3B2630]/90 leading-relaxed"
              >
                <Check />
                <span>{f}</span>
              </li>
            ))}
          </ul>

          {/* Bonus callout */}
          <div
            className="relative rounded-2xl border-2 border-[#C9587E]/50 bg-gradient-to-b from-[#C9587E]/10 via-[#F2D7DF]/40 to-[#C9587E]/10 p-8 md:p-12 mb-10 shadow-ambient"
            data-testid="bonus-callout"
          >
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 rounded-full bg-[#C9587E] px-6 py-1.5">
              <span className="font-body uppercase tracking-[0.35em] text-[11px] md:text-xs text-[#FFFCFB] font-bold">
                ✦ Bonus ✦
              </span>
            </div>
            <p className="font-serif text-2xl md:text-4xl text-[#3B2630] leading-snug text-center mt-3">
              A private <span className="italic text-[#C9587E]">45-minute welcome session</span>
            </p>
            <p className="font-serif italic text-xl md:text-2xl text-[#6B5058] leading-snug text-center mt-4">
              for the next{" "}
              <span className="not-italic font-medium text-[#C9587E]">3 women</span>{" "}
              who enroll by July 31st.
            </p>
          </div>

          <p className="text-center font-serif italic text-lg md:text-xl text-[#6B5058] mb-2">
            Starts the moment you enroll.
          </p>
          <p className="text-center font-body text-sm text-[#97808A] mb-10">
            Your first voice note could be tonight (if M&ndash;F).
          </p>

          <CTAButton
            variant="primary"
            href={CHECKOUT_URL}
            testid="cta-goldmine"
            className="w-full"
          >
            Leggo
          </CTAButton>
        </article>

        <div className="mt-14" data-testid="pricing-testimonials-wrap">
          <TestimonialBar
            testid="pricing-testimonials"
            testimonials={[TESTIMONIALS.thirtyEightK, TESTIMONIALS.fortyFourK]}
          />
        </div>
      </div>
    </section>
  );
};
